if (document.querySelector('.js-load-more-btn')) {
  document.querySelector('.js-load-more-btn').addEventListener('click', () => {
    loadMoreProducts()
  })
}
async function getNextPage() {
  try {
    const nextUrl = document.getElementById('articles-grid').dataset.nextUrl
    const res = await fetch(nextUrl)
    return await res.text()
  } catch (error) {
    console.error(error)
  }
}

async function loadMoreProducts() {
  const blogArticleList = document.getElementById('articles-grid')
  let nextUrl = blogArticleList.dataset.nextUrl

  const loadMoreBtn = document.getElementsByClassName('load-more_btn')[0]
  const loadMoreSpinner = document.getElementsByClassName('load-more_spinner')[0]
  const numberViewed = document.querySelector('.js-viewed-post')
  const perView = parseInt(numberViewed.getAttribute('per-view'))
  const numberArticlesCount = parseInt(document.querySelector('.js-articles-count').getAttribute('articles-count'))
  loadMoreBtn.style.display = 'none'
  loadMoreSpinner.style.display = 'block'
  const nextPage = await getNextPage()

  const parser = new DOMParser()
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html')

  loadMoreSpinner.style.display = 'none'

  const productgrid = nextPageDoc.querySelector('#articles-grid')
  const newProducts = productgrid.querySelectorAll('.article-card')
  const newUrl = productgrid.dataset.nextUrl
  blogArticleList.dataset.nextUrl = newUrl
  if (newUrl) {
    loadMoreBtn.style.display = 'inline-block'
  }
  nextUrl = newUrl
  for (let i = 0; i < newProducts.length; i++) {
    const singleProduct = newProducts[i].cloneNode(true)
    blogArticleList.appendChild(singleProduct)
  }
  const viewUpdate = document.querySelectorAll('.article-card').length
  if (viewUpdate >= numberArticlesCount) {
    numberViewed.innerHTML = numberArticlesCount
  } else {
    numberViewed.innerHTML = viewUpdate
  }
}
